RivalIQ.apps.Favorites.module('enums', function (enums, App, Backbone, Marionette, $, _) {

    'use strict';

    enums.copyMode = {
        NONE: 0,
        DASHBOARD: 1,
        TEMPLATE: 2
    };

});
